import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Etapa } from '../models/etapa';
import { MASKS } from 'ng-brazil';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from '../services/notificacao.service';
import { EtapaService } from '../services/etapa.service';
import { MatDialog } from '@angular/material';
import { CarregandoService } from '../services/carregando.service';
import { UtilitarioService } from '../services/utilitario.service';
import { CadastrarEtapaComponent } from './cadastrar-etapa/cadastrar-etapa.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Monitor } from '../models/monitor';
import { MonitorService } from '../services/monitor.service';

declare const $: any;

@Component({
  selector: 'app-etapa',
  templateUrl: './etapa.component.html',
  styleUrls: ['./etapa.component.scss']
})
export class EtapaComponent implements OnInit, OnDestroy, AfterViewInit {
  // variáveis
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;

  monitores: Monitor[];
  etapas: Etapa[];

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private etapaService: EtapaService,
    public dialog: MatDialog,
    private router: Router,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private monitorService: MonitorService
  ) { }

  ngOnInit() {
    this.buscarMonitores();
  }

  editarEtapa(etapa: Etapa) {
    const etapaParaEditar = new Etapa();
    Object.assign(etapaParaEditar, etapa);

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarEtapaComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { etapa: etapaParaEditar },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: Etapa) => {
      if (result) {
        etapa.descricao = result.descricao;
        etapa.textoAcompanhamento = result.textoAcompanhamento;
        etapa.enviarEmail = result.enviarEmail;
        etapa.idTemplateEmail = result.idTemplateEmail;
        etapa.somenteApi = result.somenteApi;
        etapa.visualizaIntegrador = result.visualizaIntegrador;

        this.salvar(etapa);
      }
    });
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarEtapas() {
    this.carregandoService.mostra('buscaEtapas');

    this.etapaService.consultar().subscribe(ets => {
      this.etapas = ets;
      this.carregando = false;

      this.carregandoService.esconde('buscaEtapas');
    }, (erro) => {
      this.carregandoService.esconde('buscaEtapas');
      this.notificacaoService.erro(erro);
    });
  }

  buscarMonitores() {
    this.carregandoService.mostra('buscarMonitores');

    this.etapaService.consultarComMonitores().subscribe(mon => {
      this.monitores = mon;

      this.carregando = false;

      this.carregandoService.esconde('buscarMonitores');
    }, (erro) => {
      this.carregandoService.esconde('buscarMonitores');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosFVFunil() {}

  excluirEtapa(etapa: Etapa) {

    etapa.ativa = false;
  }

  salvar(etapa: Etapa) {
    this.carregandoService.mostra('salvaEtapa');

    this.etapaService.salvar(etapa).subscribe(() => {
      this.notificacaoService.sucesso('Etapa salva com sucesso!!!');
      this.carregandoService.esconde('salvaEtapa');

    }, (erro) => {
      this.carregandoService.esconde('salvaEtapa');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {}

  etapasAtivas() {
    return this.etapas ? this.etapas.filter(p => !p.fixa && p.ativa) : [];
  }

  etapasFixas() {
    return this.etapas ? this.etapas.filter(p => p.fixa) : [];
  }

  atualizaMostrarValores(monitor) {
    this.carregandoService.mostra('atualizaMostrarValores');

    monitor.mostrarValores = !monitor.mostrarValores;

    const vm = {
      monitor: monitor.id,
      mostrarValores: monitor.mostrarValores
    }

    this.monitorService.salvar(vm).subscribe(() => {
      this.carregandoService.esconde('atualizaMostrarValores');
    },
    err => {
      this.carregandoService.esconde('atualizaMostrarValores');
      this.notificacaoService.erro(err);
    });
  }
}